import type { ILegalDocumentService, ILegalDocumentInitiateSigningData } from "./legal-document.types"
import type { ISignableDocumentData } from "@/models/legal_documents"
import axios from "@/api/axios"
import type { AxiosInstance } from "axios"

export class LegalDocumentService implements ILegalDocumentService {
  private endpoint: string

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/legal-documents/'
  }

  fetchSignableDocuments(): Promise<ISignableDocumentData[]> {
    return this.axios.get(`${this.endpoint}signable-documents/`)
      .then(({ data }) => data)
  }

  initiateDocumentSigning(data: ILegalDocumentInitiateSigningData): Promise<void> {
    return this.axios.post(`${this.endpoint}signable-documents/initiate-signing/`, data)
  }
}

const legalDocumentService = new LegalDocumentService(axios)
export default legalDocumentService